import { sanitizeRevitParameterNames } from '../../../shared/lib/revitParameterNames';

const PCF_PARAMETER_PREFIX = '#pcf_';
const STATIC_NON_PARAMETER_VALUES = new Set([
  'boltbased',
  'gasketbased',
  'formula',
  'true',
  'false',
  'yes',
  'no',
]);

export function sanitizeMappingParameterReferenceName(
  value: string | null | undefined
): string | null {
  const [sanitized] = sanitizeRevitParameterNames([value]);
  const name = sanitized?.trim() ?? '';

  if (!name) {
    return null;
  }

  if (name.startsWith('#') && !name.toLowerCase().startsWith(PCF_PARAMETER_PREFIX)) {
    return null;
  }

  return STATIC_NON_PARAMETER_VALUES.has(name.toLowerCase()) ? null : name;
}
